export default "__VITE_ASSET__Bn5GEjqa__";